export const zh_TW = {
    translation: {
        b: {
            cancel: '取消',
            confirm: '確認',
            send: '傳送',
            done: '完成',
            close: '關閉',
            clear: '清除',
            copy_link: '複製連結',
            export: '匯出',
            delete: '刪除',
            delete_confirm: '確認刪除',
            duplicate: '複製',
            share: '分享',
            sign_in: '登入',
            sign_up: '註冊',
            email_address: '電子郵件地址',
            yes: '是',
            no: '否'
        },
        m_languages: {
            title: '語言',
            subtitle: '選擇語言'
        },
        m_feedback: {
            feature: {
                name: '功能請求',
                desc: '缺少您需要的功能嗎？告訴我們 — 您的點子很重要'
            },
            feedback: {
                name: '意見回饋',
                desc: '您的回饋對我們非常重要 — 請留下簡短訊息'
            }
        },
        m_feedback_t: {
            feature: {
                name: '感謝您的建議！',
                desc: '感謝您撥冗分享想法 — 這有助於我們把產品做得更好。'
            },
            feedback: {
                name: '感謝您的回饋！',
                desc: '感謝您撥冗分享想法 — 這有助於我們把產品做得更好。'
            }
        },
        m_diagram_details: {
            name_place: '輸入專案名稱',
            desc_place: '輸入專案說明'
        },
        m_quick_share: {
            title: '快速分享',
            subtitle: '（基於查詢的連結分享）'
        },
        m_export_img: {
            title: '匯出圖片'
        },
        m_export_code: {
            title: '匯出 {{db_engine}} 程式碼',
            download_file: '下載檔案',
            copy_code: '複製程式碼'
        },
        m_sign_in_remind: {
            title: '感謝您試用 DB Design',
            subtitle: '登入或註冊即可提高資料表數量上限、儲存圖表，並解鎖更多功能。'
        },
        m_sign_in_restrict: {
            title: '登入以在 App 中做更多事',
            subtitle: '登入或註冊即可提高資料表限制、儲存圖表，並解鎖更多功能。'
        },
        m_new_diagram: {
            title: '新增圖表',
            subtitle: '選擇資料庫引擎',
            open_diagram: '開啟圖表'
        },
        m_keyboard_shortcuts: {
            title: '鍵盤快速鍵',
            ctrl_left: {
                title1: '控制',
                title2: '(左側)',
                items: {
                    mouse_sel: '滑鼠選取／手形模式',
                    table: '資料表',
                    line: '連線',
                    area: '區域',
                    note: '註記',
                    comment: '註解',
                    pen: '畫筆',
                    undo: '復原',
                    redo: '重做'
                }
            },
            ctrl_top_left: {
                title1: '控制',
                title2: '(左上角)',
                items: {
                    export_img: '匯出圖片',
                    search: '搜尋',
                    editor_panel: '編輯器面板'
                }
            },
            ctrl_bottom_right: {
                title1: '控制',
                title2: '(右下角)',
                items: {
                    minimap: '小地圖',
                    zoom_in: '放大',
                    zoom_out: '縮小',
                    zoom_100: '100% 縮放'
                }
            },
            ctx_tab: {
                title1: '內容功能表',
                title2: '(資料表)',
                items: {
                    dupl_tab: '複製資料表',
                    del_tab: '刪除資料表'
                }
            },
            ctx_del_tab: {
                title1: '內容功能表',
                title2: '(刪除資料表)',
                items: {
                    yes: '是',
                    no: '否'
                }
            },
            ctx_tab_col: {
                title1: '內容功能表',
                title2: '(資料表欄位)',
                items: {
                    add_col_below: '在下方新增欄位',
                    focus_col_above: '將焦點移至上方欄位',
                    focus_col_below: '將焦點移至下方欄位',
                    move_col_up: '將欄位上移',
                    move_col_down: '將欄位下移',
                    dupl_col: '複製欄位',
                    del_col: '刪除欄位'
                }
            },
            ctx_line: {
                title1: '內容功能表',
                title2: '(連線)',
                items: {
                    del_line: '刪除連線'
                }
            },
            ctx_area: {
                title1: '內容功能表',
                title2: '(區域)',
                items: {
                    dupl_area: '複製區域',
                    del_area: '刪除區域'
                }
            },
            ctx_multi: {
                title1: '內容功能表',
                title2: '(多重選取)',
                items: {
                    select_all: '選取所有元素',
                    create_area_for_select_els: '為選取元素建立區域',
                    dupl_select_els: '複製選取的元素',
                    del_select_els: '刪除選取的元素'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: '滑鼠選取',
                table: '資料表',
                line: '連線',
                area: '區域',
                note: '註記（即將推出）',
                comment: '註解（即將推出）',
                pen: '畫筆',
                undo: '復原',
                redo: '重做'
            },
            ctrl_top_left: {
                logo: '注意：這是沙盒（測試環境）',
                name: '圖表資訊',
                editor: '編輯器（即將推出）',
                search: '搜尋（即將推出）',
                export: '匯出選項',
                view_mode: '檢視模式',
                zoom_to_fit: '調整為適合螢幕'
            },
            ctrl_top_right: {
                feature_req: '功能請求',
                sign_in: '登入',
                quick_share: '快速分享'
            },
            ctrl_bottom_right: {
                full_screen: '全螢幕',
                minimap: '小地圖',
                zoom_out: '縮小',
                zoom_100: '100% 縮放',
                zoom_in: '放大',
                info: '資訊與資源'
            },
            ctx: {
                base: {
                    colors: {
                        default: '預設',
                        blue: '藍色',
                        green: '綠色',
                        red: '紅色',
                        purple: '紫色',
                        violet: '紫羅蘭色'
                    },
                    borders: {
                        none: '無',
                        solid: '實線',
                        dashed: '虛線',
                        dotted: '點線'
                    },
                    color: '顏色',
                    border: '邊框',
                    description: '說明',
                    description_table_place: '資料表說明',
                    description_column_place: '欄位說明',
                    description_line_place: '連線說明',
                    description_note_place: '註記說明',
                    description_area_place: '區域說明',
                    description_pen_place: '畫筆說明',
                    hide_menu: '隱藏功能表',
                    show_menu: '顯示功能表'
                },
                tab_col: {
                    add_col_below: '在下方新增欄位',
                    add_col_above: '在上方新增欄位',
                    key: 'Key',
                    keys: {
                        none: '無',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: '無',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: '欄位下移',
                    move_col_up: '欄位上移',
                    more_functions: '更多功能'
                },
                line: {
                    change_connects: '變更連接器',
                    connects: {
                        empty: '空',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: '過濾元素'
                },
                multi: {
                    filter: '過濾選取內容',
                    create_area: '建立區域'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: '完整',
            keys_only: '僅鍵',
            names_only: '僅名稱'
        },
        dropdown_ctrl_export: {
            export_img: '匯出圖片',
            export_code: '匯出 SQL 程式碼'
        },
        dropdown_ctrl_settings: {
            sign_in: '登入',
            new_project: '新增專案',
            keyboard_shortcuts: '鍵盤快速鍵',
            languages: '語言'
        },
        dropdown_ctrl_info_resources: {
            feedback: '意見回饋',
            keyboard_shortcuts: '鍵盤快速鍵',
            languages: '語言',
            homepage: '首頁'
        },
        n: {
            default: '載入中…',
            file_ready_to_download: '檔案已可供下載',
            code_copied: '程式碼已複製',
            link_copied: '連結已複製',
            please_enter_message: '請輸入訊息',
            invalid_email: '電子郵件地址無效',
            something_wrong_contact: '發生錯誤。請重新載入頁面或與我們聯絡。',
            something_wrong: '發生錯誤。請重新載入頁面。',
            sending: '傳送中…',
            request_sent: '請求已送出。謝謝！'
        }
    }
};

export const zh_TWMeta = {
    lang_origin: '繁體中文',
    lang_eng: 'Traditional Chinese',
    lang_code: 'zh-TW',
};
